import { render, staticRenderFns } from "./InfoRole.vue?vue&type=template&id=24d76529&"
import script from "./InfoRole.vue?vue&type=script&lang=js&"
export * from "./InfoRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports